import { SendEmailAuthLinkError } from "@redotech/customer-portal-sdk/rpc/schema/send-email-auth-link";
import { useLoad, useTriggerLoad } from "@redotech/react-util/load";
import { RpcClientContext } from "@redotech/redo-customer-portal-shared/contexts/rpc";
import { UserContext } from "../../contexts/user";
import { sendEmailAuthLinkErrorToText } from "../../login/dynamic-text-utils";

import { ClientError } from "@redotech/rpc/errors";
import { useContext, useState } from "react";

export const useOrderButtons = () => {
  const rpcClient = useContext(RpcClientContext);
  const hasMultipleOrdersLoad = useLoad(async () => {
    if (!rpcClient)
      return { hasMultipleOrders: false, isGiftReceiptLogin: false };
    return await rpcClient.hasMultipleOrders({});
  }, [rpcClient]);

  return {
    shouldShowAllOrdersButton:
      hasMultipleOrdersLoad.value?.hasMultipleOrders &&
      !hasMultipleOrdersLoad.value.isGiftReceiptLogin,
    shouldShowViewOrderDetailsButton:
      !hasMultipleOrdersLoad.value?.isGiftReceiptLogin,
  };
};

export const useEmailAuth = () => {
  const rpcClient = useContext(RpcClientContext);
  const user = useContext(UserContext);
  const [emailSent, setEmailSent] = useState(false);
  const [showRetry, setShowRetry] = useState(false);

  const [sendEmailLoad, triggerSendEmail] = useTriggerLoad(async () => {
    if (!rpcClient || !user?.email) return;
    try {
      await rpcClient.sendEmailAuthLink({
        email: user.email,
        baseUrl: "",
        nextUrl: "/returns-portal/orders",
      });
      setEmailSent(true);
      setTimeout(() => setShowRetry(true), 2000);
    } catch (error) {
      if (error instanceof ClientError) {
        const rpcError = error as ClientError<SendEmailAuthLinkError>;
        if (rpcError.code) {
          sendEmailLoad.error = sendEmailAuthLinkErrorToText[rpcError.code];
        }
      }
    }
  });

  return {
    emailSent,
    showRetry,
    triggerSendEmail,
    sendEmailError: sendEmailLoad.error?.message,
  };
};
